import KadarTheme from '../../../styles/theme';
import { COLOR_PALETTE } from '../../../constants/colorPalette';

const COLORS = [
  KadarTheme.palette.primary.blue1,
  KadarTheme.palette.primary.orange,
  KadarTheme.palette.primary.bluish1,
];

const getSliceFillColor = (index, hasNotStartedStatus, isHeadCountReport) => {
  const offset = hasNotStartedStatus ? 0 : 1;

  if (!isHeadCountReport) return COLORS[index + offset];

  return COLOR_PALETTE[(index + offset) % COLOR_PALETTE.length];
};

const PLACEHOLDER_CELL = {
  name: 'No Data',
  value: 1,
  fill: KadarTheme.palette.primary.bluish5,
  isPlaceholder: true,
};

export const prepareChartData = (
  data,
  isEmptyData,
  placeholderText,
  hasNotStartedStatus,
  isHeadCountReport
) => {
  const chartData = data.map((entry, index) => ({
    ...entry,
    fill: getSliceFillColor(index, hasNotStartedStatus, isHeadCountReport),
  }));

  return isEmptyData
    ? [...chartData, { ...PLACEHOLDER_CELL, placeholderText }]
    : chartData;
};
